import { useSwipePanelState } from "./SwipePanel";
import { css } from "@emotion/react";
import { Icon, IconButton } from "@minted/minted-components";
import React, { memo, useCallback } from "react";

const closeButtonStyles = {
  closeButton: css`
    align-items: center;
    display: flex;
    justify-content: flex-end;
  `,
};

export type SwipePanelCloseButtonProps = {
  onCancel?: () => void;
};

const SwipePanelCloseButton = ({ onCancel }: SwipePanelCloseButtonProps) => {
  const { close } = useSwipePanelState();

  const handleClick = useCallback(() => {
    if (onCancel) {
      onCancel();
    }
    close();
  }, [onCancel, close]);

  return (
    <div css={closeButtonStyles.closeButton}>
      <IconButton
        iconType={Icon.types.close}
        onClick={handleClick}
        type="secondary"
      />
    </div>
  );
};

const MemoizedSwipePanelCloseButton = memo(SwipePanelCloseButton);

export { MemoizedSwipePanelCloseButton as SwipePanelCloseButton };
